import { createContext } from 'react';
import { AuthContextValue } from './types';

const defaultAuthContextValue: AuthContextValue = {
  profile: null,
  isAuthenticated: false,
  loading: false,
  refetchProfile: () => Promise.resolve()
};

export const AuthContext = createContext<AuthContextValue>(
  defaultAuthContextValue
);
